const selectStyles = {
    control: (styles) => ({
        ...styles,
        borderColor: "black",
        borderRadius: "10px",
        border: "1px solid #9e9e9e",
        height: "41px" ,

    }),
    menuList: (styles) => ({
        ...styles,
        maxHeight: "160px",
    }),
    menuPortal: (styles) => ({
        ...styles,
        zIndex: 1200,
    }),
};
export default selectStyles